export default __webpack_public_path__ + "static/media/FTSE_Rankings_Report_Q1_2020.4cd02fd0.pdf";